export default {
  'emailLog.title': '邮件记录',
  'emailLog.form.merchant': '商户',
  'emailLog.form.merchant.placeholder': '请选择商户',
  'emailLog.form.shopifyId': 'Shopify ID',
  'emailLog.form.shopifyId.placeholder': 'Shopify ID',
  'emailLog.form.toEmail': '收件人邮箱',
  'emailLog.form.toEmail.placeholder': '收件人邮箱',
  'emailLog.form.contentType': '模板类型',
  'emailLog.form.contentType.placeholder': '请选择模板类型',
  'emailLog.form.status': '发送状态',
  'emailLog.form.status.placeholder': '请选择发送状态',
  'emailLog.form.isRead': '是否已读',
  'emailLog.form.isRead.placeholder': '请选择是否已读',
  'emailLog.form.dateRange': '创建时间',
  'emailLog.form.startDate': '开始日期',
  'emailLog.form.endDate': '结束日期',
  'emailLog.form.search': '查询',
  'emailLog.form.reset': '重置',
  'emailLog.columns.index': '#',
  'emailLog.columns.merchant': '商户',
  'emailLog.columns.shopifyId': 'Shopify ID',
  'emailLog.columns.toEmail': '收件人',
  'emailLog.columns.subject': '邮件主题',
  'emailLog.columns.contentType': '模板类型',
  'emailLog.columns.status': '发送状态',
  'emailLog.columns.isRead': '是否已读',
  'emailLog.columns.retryCount': '重试次数',
  'emailLog.columns.errorMessage': '错误信息',
  'emailLog.columns.messageId': '消息 ID',
  'emailLog.columns.createdAt': '创建时间',
  'emailLog.columns.sentAt': '发送时间',
  'emailLog.columns.readAt': '阅读时间',
  'emailLog.columns.operations': '操作',
  'emailLog.columns.operations.view': '详情',
  'emailLog.status.sending': '发送中',
  'emailLog.status.success': '成功',
  'emailLog.status.failed': '失败',
  'emailLog.isRead.unread': '未读',
  'emailLog.isRead.read': '已读',
  'emailLog.detail.title': '邮件详情',
  'emailLog.detail.content': '邮件内容',
  'emailLog.detail.config': '配置信息',
  'emailLog.detail.response': '发送返回值',
  'emailLog.detail.responseCode': '返回码',
  'emailLog.detail.errorMessage': '错误信息',
  'emailLog.detail.updatedAt': '更新时间',
  'emailLog.detail.empty': '暂无内容',
};
